export default "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJ6U3BhY2VMb2dvXzExMHgzMi41NGQ0NGJmMTkxMGM1NjI3YjBkZC5wbmciOw=="